import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { VITE_BACKEND_URL } from '../../enviroment';
import { IRequest, RequestMethod } from '../request';
import { trackApiError } from '../../lib/sentry';

// Set the base URL for all HTTP requests using Axios
axios.defaults.baseURL = VITE_BACKEND_URL;

export const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value?.split(`; ${name}=`);
  //@ts-ignore
  if (parts.length === 2) return parts.pop()?.split(';').shift();
};

// Define a function for making HTTP requests
export const HttpRequest = async (request: IRequest): Promise<unknown> => {
  // dd
  try {
    const { url, method, body, headers } = request;
    const { GET, POST, PATCH, PUT, DELETE } = RequestMethod;

    /*      set a default header with token          */

    // Set your default headers, including the token

    const token = getCookie('accessToken');
    let config: AxiosRequestConfig;

    if (token) {
      const defaultHeaders = {
        Authorization: `Bearer ${token}` // Use the actual token from local storage
        // Add other default headers if needed
      };

      // Merge default headers with the provided headers
      config = {
        headers: { ...defaultHeaders, ...headers }
      };
    } else {
      // Use the provided headers without modifying them
      config = {
        headers
      };
    }

    // Define a mapping of request methods to Axios functions
    const requestMethods = {
      [GET]: axios.get,
      [POST]: axios.post,
      [PATCH]: axios.patch,
      [DELETE]: axios.delete,
      [PUT]: axios.put
    };

    // Get the appropriate Axios function for the specified request method
    const requestMethod = requestMethods[method];
    if (!requestMethod)
      return {
        message: `Only Methods ${Object.keys(RequestMethod)} are allowed`
      };
    // Make the HTTP request using Axios
    if (method === GET || method === DELETE) {
      const response: AxiosResponse = await requestMethod(url, config);
      return response.data;
    }
    const response: AxiosResponse = await requestMethod(url, body, config);

    return response.data;
  } catch (error: unknown) {
    // Track API errors with Sentry
    if (axios.isAxiosError(error)) {
      trackApiError(error, request.url, request.method);
    }

    // Handle errors
    if (axios.isAxiosError(error)) {
      // const axiosError = error as AxiosError;

      // if (axiosError.response) {
      //   const { status, data }: any = axiosError.response;
      //     if (status == 401) {
      //     toast.error(data.message, { toastId: 'blocked' });
      //     document.cookie = 'accessToken=; path=/; expires=0;';
      //     document.cookie?.split(';').forEach((c) => {
      //       document.cookie = c
      //         .replace(/^ +/, '')
      //         .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
      //     });
      //     window.location.replace(window.location.origin + '/logout');
      //     return;
      //   }
      //   if (status == 403) {
      //     toast.error(data.message, { toastId: 'blocked' });
      //     document.cookie = 'accessToken=; path=/; expires=0;';
      //     document.cookie?.split(';').forEach((c) => {
      //       document.cookie = c
      //         .replace(/^ +/, '')
      //         .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
      //     });
      //     window.location.replace(window.location.origin + '/logout');
      //     return;
      //   }
      //   return data;
      // }
      return;
    }
    return error; // Return the error object if it's not an AxiosError or if there's no response
  }
};

/// +++>>  Refactored Method. Use in new flows <<+++ ///
// utils/axiosClient.ts

type WrappedResponse<T> = {
  data: T;
  status: number;
  success: boolean;
  statusText: string;
  headers: any;
};

export const HttpClient = async <T = any>(config: AxiosRequestConfig): Promise<WrappedResponse<T>> => {
  const token = getCookie('accessToken'); // Adjust cookie name if needed

  const headers = {
    ...config.headers,
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };

  try {
    const response: AxiosResponse<T> = await axios({ ...config, headers });
    return {
      data: response.data,
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
      success: response.status >= 200 && response.status < 300
    };
  } catch (error) {
    // Track API errors with Sentry
    if (axios.isAxiosError(error)) {
      trackApiError(error, config.url || 'unknown', config.method || 'unknown');
    }
    throw error;
  }
};
